import React from 'react'
import DandadIcon from '../../Icons/Dandad/Dandad'
import getClickableProps from '../../Clickble/Clickable'
import "./TopNav.css";
import { CloseButton } from 'react-bootstrap';
import { Link } from 'gatsby';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons'
import {faFacebookSquare, faInstagram, faTwitter} from '@fortawesome/free-brands-svg-icons'
import NavSearch from '../Search/Search'
import SearchIcon from '../../Icons/Search/Search'
import NewsletterSubscribe from '../../NewsletterSubscribe/NewsletterSubscribe'

const TopNav = ({awardType, location}) => {
  const [expand, setExpand] = React.useState(false)
  const [searchOpen, setSearchOpen] = React.useState(false)
  const [newsletterOpen, setNewsletterOpen] = React.useState(false)

  React.useEffect(() => {
    setExpand(false)
  }, [location])

  const searchHandler = React.useCallback(() => {
    setSearchOpen(true)
    setExpand(false)
  }, [setSearchOpen, setExpand])

  const closeHandler = () => {
    setTimeout(() => setSearchOpen(false), 1000)
  }

  return (
    <>
      {searchOpen && !expand &&
        <div className="mobile-search-wrapper d-lg-none">
          <NavSearch awardType={awardType} closeHandler={closeHandler} isOpen={true} />
        </div>
      }
      <NewsletterSubscribe show={newsletterOpen} close={() => setNewsletterOpen(false)} />
      <nav className={`top-nav transition ${awardType ? awardType : ""} ${expand ? "expanded" : "closed"}`}>
        <div
            className="menu-link"
            {...getClickableProps(() => setExpand(!expand))}
          >
            Menu
        </div>
        <div className="transition expandable-section">
          <CloseButton
            className="close-button"
            {...getClickableProps(() => setExpand(!expand))}
          />
          <ul className="large">
            <li><Link to="/home/professional/"><span className="xLarge">D&AD Awards 2020</span></Link></li>
            <li><Link to="/editorial/about/"><span className="xLarge">About the Awards</span></Link></li>
            <li><Link to="/dandad2020/d-ad-in-2020/"><span>D&AD in 2020</span></Link></li>
            <li><Link to="/insights/videos/"><span>Insights</span></Link></li>
            <li><Link to="/rankings/advertising-agency/"><span>Rankings</span></Link></li>
            <li><Link to="/people/board/"><span>People</span></Link></li>
          </ul>

          <div className="top-nav-menu-padded-link large">
            <Link to="/home/newblood">
              <span className="xLarge">New Blood Awards</span><br/>
            </Link>
          </div>

          <div className="top-nav-menu-bottom">
            <span className="extra-links"><Link to="/editorial/credits/">Credits</Link> | <a href="https://www.dandad.org/">www.dandad.org</a></span>
            <span className="subscribe-link" target="_blank" onClick={() => setNewsletterOpen(true)}>
              <FontAwesomeIcon icon={faPencilAlt}/>
              <span className="d-none d-lg-inline">Sign up to the D&AD newsletter</span>
            </span>
            <a className="social-link" href="https://www.facebook.com/DandADuk"><FontAwesomeIcon icon={faFacebookSquare} /></a>
            <a className="social-link" href="https://twitter.com/dandad"><FontAwesomeIcon icon={faTwitter} /></a>
            <a className="social-link" href="https://instagram.com/D_and_AD"><FontAwesomeIcon icon={faInstagram} /></a>
            <div className="search-wrapper d-block d-lg-none" {...getClickableProps(searchHandler)}>
              <div className="search-button">
                <SearchIcon /> <span className="search-label">Search</span>
              </div>
            </div>
          </div>
        </div>
        <div className="links">
          <div className="home-icon-wrapper d-block d-lg-none">
            <a href="https://dandad.org/"><DandadIcon /></a>
          </div>
          <div className="spacer" />
        </div>
      </nav>
    </>
  )
}

export default TopNav;
